import actions from "./actions";

export default {
  namespaced: true,
  state: {
    meet: null,
    resource: null,
    goals: [],
    history: [],
    threeExercises: [],
    fiveExercises: [],
    recorded: [],
    exercise: {},
    count: null
  },
  mutations: {
    setMeet(state, meet) {
      state.meet = meet;
    },
    setResource(state, resource) {
      state.resource = resource;
    },
    setGoals(state, goals) {
      state.goals = goals;
    },
    setHistory(state, history) {
      state.history = history;
    },
    addHistory(state, history) {
      state.history = [...state.history, ...history];
    },
    setThreeExercises(state, threeExercises) {
      state.threeExercises = threeExercises;
    },
    setFiveExercises(state, fiveExercises) {
      state.fiveExercises = fiveExercises;
    },
    setExercise(state, exercise) {
      state.exercise = exercise;
    },
    setRecordedExercises(state, recorded) {
      state.recorded = recorded;
    },
    setCount(state, count) {
      state.count = count;
    }
  },
  actions
};
